
import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiInstagram, FiLinkedin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-neutral-950 py-12 border-t border-neutral-900 text-neutral-400">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6">
        <a href="#" className="flex items-center">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/1a35cb15935008635dadd9d4f6191635.png" 
            alt="VZION by DASZeph" 
            className="h-8 md:h-10 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
          />
        </a>
        
        <div className="text-sm font-light">
          &copy; {new Date().getFullYear()} VZION by DASZeph. All rights reserved.
        </div>

        <div className="flex space-x-6">
          <a href="#" className="hover:text-white transition-colors">
            <SafeIcon icon={FiInstagram} className="w-5 h-5" />
          </a>
          <a href="#" className="hover:text-white transition-colors">
            <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
